An event in a stream.
